module.exports = __webpack_public_path__ + "static/transfer_request3-1bce9f63eb93574092622046051e163f.png";